module.exports = __webpack_public_path__ + "img/1_windAndRain_dgl.7dfb05b5.png";